'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base';
import analytics from '../utils/analytics';
import clickableContainer from '../ui/clickable-container';

const classNames = {
	cfsHub: 'cfs-hub',
	cfsHubFilters: 'cfs-hub-filters',
	cfsResultItem: 'cfs-result-item',
	moreModifier: 'more',
	popularLinksListItem: 'popular-links__list__item',
	popularLinksShowMoreButton: 'popular-links__show-more-button',
	results: 'results',
	title: 'title'
}

export function init() {
	baseInit();

	import(/* webpackChunkName: "react-cfs-hub" */ '../react/entry/cfs-hub.js').then(function ({ renderSearch }) {
		const $cfsHubFilters = $.findByBem(classNames.cfsHubFilters);
		if ($cfsHubFilters.length > 0) {
			renderSearch();
		}
	});

	$.findByBem(classNames.cfsResultItem, classNames.title).off('click.analytics').on('click.analytics', (event) => {
		const $resultsContainer = $(event.target).closestByBem(classNames.cfsHub, classNames.results);
		const trackingCategory = $resultsContainer.attr('data-ga-sale-type') + ' CFS detail click through';
		const trackingLabel = $resultsContainer.attr('data-ga-label-prefix') + ' CFS landing page';

		analytics.trackEvent(trackingCategory, 'Click', trackingLabel);
	});

	const $morePopularLinks = $.findByBem(classNames.cfsHub, classNames.popularLinksListItem, classNames.moreModifier);
	const $showMorePopularLinks = $.findByBem(classNames.cfsHub, classNames.popularLinksShowMoreButton);
	$showMorePopularLinks.off('click.popular-links').on('click.popular-links', () => {
		$morePopularLinks.show();
		$showMorePopularLinks.hide();
	});

	clickableContainer.init();
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}